module.exports = __webpack_public_path__ + "media/ding3.8c0bd207.mp3";